import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { INPUT } from "./obUi";

export const TermsEditor = ({ onSaved }) => {
  const [t, setT] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/onboarding-terms").then((r) => { setT(r.data); setText(r.data.is_placeholder ? "" : r.data.text); }).catch(() => setT(false));
  }, []);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/onboarding-terms", { text });
      setT(data);
      onSaved();
      toast.success("Lead terms saved");
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || "Couldn't save"); }
    finally { setBusy(false); }
  };
  if (!t) return null;
  return (
    <details className="border-2 border-black bg-white p-4 mb-6 group" open={t.is_placeholder} data-testid="ob-terms-editor">
      <summary className="cursor-pointer label-mono">Lead terms buyers agree to {t.is_placeholder && <span className="text-red-700">— not set yet</span>}</summary>
      <p className="text-xs text-zinc-600 mt-2 mb-2">Every setup form shows these terms. Buyers must tick “I agree” and type their name.</p>
      <textarea rows={8} className={INPUT} value={text} onChange={(e) => setText(e.target.value)} placeholder="Write your lead terms here: pricing, returns, payment, exclusivity…" data-testid="ob-terms-input" />
      <button type="button" onClick={save} disabled={busy || text.trim().length < 10} data-testid="ob-terms-save"
              className="mt-2 bg-black text-white px-4 py-2 text-[11px] font-bold uppercase tracking-widest hover:bg-zinc-800 transition-colors duration-100 disabled:opacity-40">
        {busy ? "Saving…" : "Save terms"}
      </button>
    </details>
  );
};
